import { render, staticRenderFns } from "./KouYuYangBen.vue?vue&type=template&id=24ca8e54&scoped=true"
import script from "./KouYuYangBen.vue?vue&type=script&lang=js"
export * from "./KouYuYangBen.vue?vue&type=script&lang=js"
import style0 from "./KouYuYangBen.vue?vue&type=style&index=0&id=24ca8e54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ca8e54",
  null
  
)

export default component.exports